import React, { useEffect, useState } from 'react'
import { useAppData } from '../../../../../context/AppDataContext'

function VendorTransactionAnalytics({transactionItemList}) {

    const {vendorDD} = useAppData();

    const [vendorData,setVendorData] = useState(null)

    const prepareData = () =>{
        let _data =[];
        vendorDD.forEach((v,i)=>{
            _data[i] = v;
            _data[i].amount = 0;
            transactionItemList.forEach(t => {
                if(t.payeeType == 2 && t.payeeId == _data[i].value) {
                    _data[i].amount = Number(_data[i].amount+t.amount) 
                }
            });
        })
        setVendorData(_data);
    }

    useEffect(()=>{
        if(transactionItemList){
            prepareData()
        }
    },[transactionItemList])

    const calculateTotal = () => {
        return vendorData.reduce((accumulator, currentObject) => {
            // We use Number() to ensure we don't accidentally concatenate strings
            return accumulator + Number(currentObject.amount || 0);
        }, 0);
    };

    return (
        vendorData &&
        <table className='table table-bordered table-striped'>
            <thead>
                <tr><th colSpan={2}className='text-center table-dark' >Vendor Payment</th></tr>
                <tr>
                    <th>Vendor Name</th>
                    <th>Amount</th>
                </tr>
            </thead>
            <tbody>
                {vendorData.map(vendor=>
                    vendor.amount > 0 &&
                    <tr key={vendor.value}>
                        <td>{vendor.label}</td>
                        <td>{vendor.amount}</td>
                    </tr>
                )}
            </tbody>
            <tfoot>
                <tr>
                    <th>Total</th>
                    <th>{calculateTotal()}</th>
                </tr>
            </tfoot>
        </table>
    )
}

export default VendorTransactionAnalytics